package com.loyola.acessoescola.ui.login


import androidx.lifecycle.ViewModel
import com.loyola.acessoescola.services.QuickAuthClient
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch

val appScope = MainScope()

class LoginViewModel(
    val authClient: QuickAuthClient
) : ViewModel() {
    fun authClientSign(onSuccessCallBack: (List<String>) -> Unit, onErrorCallBack: (String) -> Unit) {
        appScope.launch {
            try {
                authClient.sign(
                    onSuccessCallBack = { getAppRole { appRoles -> onSuccessCallBack(appRoles)} }
                ) { onErrorCallBack("") }
            } catch (e: Exception) {
                onErrorCallBack(e.message ?: "")
            }
        }
    }

    fun getAppRole(callBack: (List<String>) -> Unit){
        authClient.getAppRoles { appRoles ->
            callBack(appRoles)
        }
    }


}